<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import Vue from "vue";
export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "knowledgeClass",
        key: "id",
        url: {
          del: "/admin/system/type",
        },
        output: false,
      },
      actions: [
        {
          label: "新增",
          icon: "md-add",
          onClick: this.toAdd,
          type: "info",
          auth: "system/knowledgeBaseClass/add",
        },
      ],
      menus: [
        {
          label: "知识库",
          name: "knowledgeBase_list",
          auth: "system/knowledgeBase/index",
        },
        // {
        //   label: "知识库分类",
        //   name: "knowledgeBaseClass_list",
        //   auth: "system/knowledgeBaseClass/index",
        // },
        // {
        //   label: "知识库标签",
        //   name: "knowledgeBaseTag_list",
        //   auth: "system/knowledgeBaseTag/index",
        // },
      ],
      filters: [
        {
          label: "分类名称",
          KeyEnter: this.search,
          name: "name",
          value: "",
          type: "input",
        },
      ],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "分类名称",
          key: "name",
          minWidth: 120,
          align: "center",
        },
        // {
        //   title: '图标',
        //   key: 'imgUrl',
        //   minWidth: 120,
        //   align: 'left',
        //   viewimage: true,
        // },
        {
          title: "创建人",
          align: "center",
          key: "createBy",
        },
        {
          title: "创建时间",
          width: 150,
          align: "center",
          key: "createTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.createTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },

        {
          title: "操作",
          align: "center",
          width: 150,
          key: "handle",
          fixed: "right",
          handle: ["edit", "delete"],
          auth: {
            edit: "system/knowledgeBaseClass/edit",
            del: "system/knowledgeBaseClass/delete",
          },
        },
      ],
    };
  },
  created() {},
  methods: {
    toAdd() {
      $utils.url.push({
        name: "knowledgeBaseClass_add",
        query: { action: "add" },
      });
    },
    handleEdit(row) {
      let kv = row.id
      $utils.url.push({ name: 'knowledgeBaseClass_edit', query: { action: 'edit', kv: kv } })
    },
  },
};
</script>
<style scoped></style>
